// TODO: these could be inspected on the client -- pull into an API?
// perhaps something for a Strapi admin panel

const promoCodes = [
  {
    promo: "LONGBOWFRIENDS",
    discount: 100,
    trial: 0,
  },
  {
    promo: "LONGBOW20OFF",
    discount: 20,
    trial: 0,
  },
  {
    promo: "10DAYSFOR10",
    discount: 0,
    trial: 10,
  },
  {
    promo: "LONGBOW",
    discount: 100,
  },
  {
    promo: "HOLIDAY22",
    discount: 100,
  },
];

export default promoCodes;
